import React, { forwardRef } from 'react';
import {
  EVTextField,
  EVInputLabel,
  EVGrid,
  EVFormHelperText,
} from '@eagleview/ev-comp-library';
import PropTypes from 'prop-types';
import useStyles from './InputFieldStyle';

const InputField = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    labelText, inputId, inputValue, isRequired, handleChange, errorMessage, handleBlur, isDisabled, labelHeight,
  } = props;
  return (
    <EVGrid className={classes.inputContainer}>
      <EVInputLabel
        className={classes.label}
        style={{ height: labelHeight }}
        required={isRequired}
        classes={{ asterisk: classes.asterisk }}
        error={errorMessage.length > 0}
        htmlFor={inputId}
      >
        {labelText}
      </EVInputLabel>
      <EVTextField
        fullWidth
        id={inputId}
        classes={{ root: classes.inputText }}
        error={errorMessage.length > 0}
        value={inputValue}
        variant="outlined"
        onChange={handleChange}
        onBlur={handleBlur}
        size="small"
        disabled={isDisabled}
        inputRef={ref}
      />
      <EVFormHelperText className={classes.error}>{errorMessage}</EVFormHelperText>
    </EVGrid>
  );
});

InputField.propTypes = {
  /**
   * @property {string} labelText - Text to be used as label
   */
  labelText: PropTypes.string,
  /**
   * @property {string} inputId - Id of EVTextField
   */
  inputId: PropTypes.string.isRequired,
  /**
   * @property {number} inputValue - Value of EVTextField
   */
  inputValue: PropTypes.string,
  /**
   * @property {Function} handleChange - Function to handle change in input value in EVTextField
   */
  handleChange: PropTypes.func.isRequired,
  /**
   * @property {Function} handleBlur - Function to handle blur in input value in EVTextField
   */
  handleBlur: PropTypes.func,
  /**
   * @property {string} errorMessage - Error message to be displayed by helper text
   */
  errorMessage: PropTypes.string,
  /**
  * @property {bool} isDisabled - boolean value to disable the component
   */
  isDisabled: PropTypes.bool,
  /**
  * @property {bool} isRequired - isRequired for component
   */
  isRequired: PropTypes.bool,
  /**
   * @property {string} labelHeight - labelHeight for Label
   */
  labelHeight: PropTypes.string,
};

InputField.defaultProps = {
  labelText: '',
  inputValue: '',
  isDisabled: false,
  isRequired: false,
  errorMessage: '',
  labelHeight: '24px',
  handleBlur: () => {
    //
  },
};

export default InputField;
